import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
	clearMetaInfo,
	setFormMetaInfo,
	setToReviewForms
} from '../../../../components/FormBuilderLibrary/slice';

import ButtonDropdown from '../../../../components/core/ButtonDropdown/ButtonDropdown';
import { STAGE_APPLICATION, STAGE_CREATION_PARAM, STAGE_EVALUATION } from './constants';

const ActionButton = ({
	type,
	clickedRow,
	hasSubmissionStage,
	last_stage,
	isReadyToPublish,
	setWarningModal
}) => {
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const last_stage_is_submission = last_stage?.type === 'Submission Stage';

	const rowType = type?.toLowerCase();
	const addStageButton = {
		title: 'ADD STAGE',
		id: 198567,
		tipPlacement: 'left',
		variant: 'contained',
		marginBottom: '0px',
		popperPlacement: 'bottom-end',
		tipTitle: last_stage_is_submission
			? 'Evaluation Stage must be added to close block.'
			: 'In order to add a Evaluation Stage, you must first add a Submission Stage.',
		options: [
			{
				disabled: last_stage_is_submission,
				title: 'Submission Stage - From Scratch',
				onClick: () => {
					dispatch(clearMetaInfo());
					setSearchParams({ ...searchParams, [STAGE_CREATION_PARAM]: STAGE_APPLICATION });
				}
			},
			{
				disabled: last_stage_is_submission,
				title: 'Submission Stage - Using Template',
				individiualTooltip: 'Templates currently unavailable.',
				onClick: () => {
					setSearchParams({
						...searchParams,
						templatesModal: 'submission-stage',
						stageId: clickedRow?.appId
					});
				}
			},
			{
				disabled: !hasSubmissionStage,
				title: 'Evaluation Stage - From Scratch',
				onClick: () => {
					dispatch(clearMetaInfo());
					setSearchParams({ ...searchParams, [STAGE_CREATION_PARAM]: STAGE_EVALUATION });
				}
			},
			{
				disabled: !hasSubmissionStage,
				title: 'Evaluation Stage - Using Template',
				individiualTooltip: 'Templates currently unavailable.',
				onClick: () => {
					setSearchParams({
						...searchParams,
						templatesModal: 'evaluation-stage',
						stageId: clickedRow?.appId
					});
				}
			}
		]
	};

	const addFormButton = {
		title: 'ADD Form',
		id: 198568,
		tipPlacement: 'left',
		variant: 'outlined',
		marginBottom: '0px',
		popperPlacement: 'bottom-end',
		tipTitle: '',
		options:
			rowType === 'submission stage'
				? [
						{
							title: 'Application Form - From Scratch',
							onClick: () => {
								dispatch(
									setFormMetaInfo({
										stage_title: clickedRow?.title
									})
								);
								if (isReadyToPublish) {
									setWarningModal({
										open: true,
										creationType: 'form',
										formBuilder: 'application',
										formId: clickedRow?.form_id,
										stageId: clickedRow?.appId
									});
								} else {
									setSearchParams({
										...searchParams,
										formBuilder: 'application',
										formId: clickedRow?.form_id,
										stageId: clickedRow?.appId
									});
								}
							}
						},
						{
							title: 'Application Form - Using Template',
							individiualTooltip: 'Templates currently unavailable.',
							onClick: () => {
								if (isReadyToPublish) {
									setWarningModal({
										creationType: 'form',
										templatesModal: 'application-form',
										stageId: clickedRow?.appId
									});
								} else {
									setSearchParams({
										...searchParams,
										templatesModal: 'application-form',
										stageId: clickedRow?.appId
									});
								}
							}
						}
				  ]
				: [
						{
							title: 'Review Form - From Scratch',
							onClick: () => {
								dispatch(
									setFormMetaInfo({
										stage_title: clickedRow?.title
									})
								);
								dispatch(setToReviewForms(clickedRow?.review_info || []));
								if (isReadyToPublish) {
									setWarningModal({
										open: true,
										creationType: 'form',
										formBuilder: 'review',
										formId: clickedRow?.form_id,
										stageId: clickedRow?.appId
									});
								} else {
									setSearchParams({
										...searchParams,
										formBuilder: 'review',
										formId: clickedRow?.form_id,
										stageId: clickedRow?.appId
									});
								}
							}
						},
						{
							title: 'Review Form - Using Template',
							onClick: () => {
								if (isReadyToPublish) {
									setWarningModal({
										creationType: 'form',
										templatesModal: 'review-form',
										stageId: clickedRow?.appId
									});
								} else {
									setSearchParams({
										...searchParams,
										templatesModal: 'review-form',
										stageId: clickedRow?.appId
									});
								}
							}
						}
				  ]
	};

	return !rowType?.includes('form') ? (
		<ButtonDropdown data={rowType?.includes('stage') ? addFormButton : addStageButton} />
	) : (
		<ButtonDropdown data={addFormButton} hidden />
	);
};

export default ActionButton;
